import { css } from '@emotion/react';

import { Button } from '../../components/buttons';
import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';

export const AfterRatingButton = styled(Button)(
	({
		theme: {
			afterRatingField: {
				text: {
					afterRatingButton: { borderBottom, ...others },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({ '&>span': { borderBottom }, ...others }),
	css`
		margin-top: 16px;
		cursor: pointer;
	`
);
